import { render } from "./PaymentHistoryModal.vue?vue&type=template&id=67481480"
import script from "./PaymentHistoryModal.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__